webpackJsonp([0],{

/***/ "+8qD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Viewer_vue__ = __webpack_require__("vNKR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_983a84e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Viewer_vue__ = __webpack_require__("KzMV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Viewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_983a84e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Viewer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Lxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "navbar has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "data-target": "mainMenu"
    },
    on: {
      "click": _vm.toggleBurger
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "id": "mainMenu"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item r-item",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("STATS50@TCD")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item r-item",
    attrs: {
      "to": "isa"
    }
  }, [_vm._v("ISA short course")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item r-item",
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v("Gallery")])], 1)])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer is-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Contacts: "), _c('a', {
    attrs: {
      "href": "mailto:arwhite@tcd.ie"
    }
  }, [_vm._v("Arthur White")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "mailto:wyseja@tcd.ie"
    }
  }, [_vm._v("Jason Wyse")])])]), _vm._v(" "), _c('div', {
    staticClass: "column copyr has-text-centered"
  }, [_c('p', [_vm._v("\n            copyright @2017 "), _c('a', {
    attrs: {
      "href": "http://www.bernardonipoti.com/",
      "target": "_blank"
    }
  }, [_vm._v("Bernardo Nipoti")])]), _vm._v(" "), _c('p', [_vm._v("\n            developed by "), _c('a', {
    attrs: {
      "href": "http://sanvisimo.it",
      "target": "_blank"
    }
  }, [_vm._v("sanvisimo")])])]), _vm._v(" "), _c('div', {
    staticClass: "column has-text-right"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.tcd.ie/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("EHON"),
      "alt": "TCD"
    }
  })])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "57eG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("nNh1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5455897c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("HDhG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5455897c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9C2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                    " + _vm._s(_vm.heading) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "is-two-thirds column is-paddingless"
  }, [_c('h2', {
    staticClass: "subtitle is-4"
  }, [_vm._v(_vm._s(_vm.subheading))])])])])]), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns pd is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-quarter-desktop"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("n26P"),
      "alt": "ISA"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds-desktop info"
  }, [_c('h3', [_vm._v("Speakers:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.eeecs.qub.ac.uk/~c.decampos/",
      "target": "_blank"
    }
  }, [_vm._v("Cassio P. de Campos")]), _vm._v(", Reader with the Centre for Data Science and Scalable Computing, Queen's University Belfast")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://people.idsia.ch/~alessandro/"
    }
  }, [_vm._v("Alessandro Antonucci")]), _vm._v(", Senior Researcher, Swiss AI Lab IDSIA")])]), _vm._v(" "), _c('h3', [_vm._v("Course description:")]), _vm._v(" "), _c('p', [_vm._v("\n                        Probabilistic models usually need a sharp estimate of their parameters in order to represent a (single) distribution, even if a precise elicitation might be unreliable because of limited expert knowledge, or observations might be scarce, incomplete and/or noisy. Instead, one may resort to sets of probability distributions to represent their knowledge, adopting the so-called theory of imprecise probability. During this tutorial we introduce the main concepts of such methods and present a number of techniques based on it that are designed to cope with uncertainty in a principled robust manner and to yield reliable results. We discuss on robust decision making and sensitivity analysis. Applications in computer vision, pattern recognition and decision support in knowledge-based expert systems are also provided.\n                        "), _c('br'), _c('br'), _vm._v("\n                        The course will consist of four lectures. Tea/coffee breaks and lunch are included in the registration fee.\n                        "), _c('br'), _vm._v("\n                        You can register by e-mailing "), _c('a', {
    attrs: {
      "href": "mailto:wyseja@tcd.ie"
    }
  }, [_vm._v("wyseja@tcd.ie")]), _vm._v(".\n                        "), _c('br'), _c('br'), _vm._v("\n                        The course is sponsored by the "), _c('a', {
    attrs: {
      "href": "http://www.istat.ie/drupal/",
      "target": "_blank"
    }
  }, [_vm._v("Irish Statistical Association")]), _vm._v(".\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns pd is-multiline is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Venue of the event")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.google.ie/maps/place/O'Callaghan+Mont+Clare+Hotel/@53.3414972,-6.2530017,17z/data=!3m1!4b1!4m5!3m4!1s0x48670e90db4a8129:0xcf06339f781c38e2!8m2!3d53.341494!4d-6.250813",
      "target": "_blank"
    }
  }, [_vm._v("\n                                O'Callaghan Mont Clare Hotel"), _c('br'), _vm._v("\n                                1-4 Merrion Street Lower, Dublin 2\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Registration fees")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-vcentered"
  }, [_c('i', {
    staticClass: "fa fa-eur",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Student €20, full €30"), _c('br'), _vm._v("\n                            Discount for ISA members 50%\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds-desktop"
  }, [_c('div', {
    staticClass: "card schedule"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Schedule of events")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Tuesday, 14th of November, 2017")]), _vm._v(" "), _c('ul', {
    staticClass: "subtitle is-vcentered"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("9:00 am - 9:30 am:")]), _vm._v(" Register")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("9:30 am - 10:30 am:")]), _vm._v(" Lecture 1")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("10:30 am - 10:45 am:")]), _vm._v(" Coffee break")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("10:45 am - 11:45 am:")]), _vm._v(" Lecture 2")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("11:45 am - 12:45 am:")]), _vm._v(" Lunch")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("12:45 am - 13:45 am:")]), _vm._v(" Lecture 3")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("13:45 am - 14:00 am:")]), _vm._v(" Coffee break")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("14:00 am - 15:00 am:")]), _vm._v(" Lecture 4")])])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9MfB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/trinity-stacked.42a9ae9.jpg";

/***/ }),

/***/ "EHON":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/trinity-common-use-white.1117faa.png";

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'home',
    beforeCreate: function beforeCreate() {
        document.body.className = 'bodyHome';
    },
    data: function data() {
        return {
            heading: '50th Anniversary of the Discipline of Statistics'
        };
    }
});

/***/ }),

/***/ "HDhG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HKjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gallery_AppHeader__ = __webpack_require__("57eG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gallery_Thumbs__ = __webpack_require__("UB0V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gallery_Viewer__ = __webpack_require__("+8qD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gallery_event_bus__ = __webpack_require__("ShYa");
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'gallery',
    components: {
        AppHeader: __WEBPACK_IMPORTED_MODULE_0__gallery_AppHeader__["a" /* default */],
        Thumbs: __WEBPACK_IMPORTED_MODULE_1__gallery_Thumbs__["a" /* default */],
        Viewer: __WEBPACK_IMPORTED_MODULE_2__gallery_Viewer__["a" /* default */]
    },
    beforeCreate: function beforeCreate() {
        document.body.className = 'gallery';
    },
    created: function created() {
        this.item = { 'imgix_url': 'static/gallery/DSC_6067.jpg' };
        __WEBPACK_IMPORTED_MODULE_3__gallery_event_bus__["a" /* EventBus */].$emit('loaded', this.item);
    },
    data: function data() {
        return {
            item: {}
        };
    }
});

/***/ }),

/***/ "Id0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Isa_vue__ = __webpack_require__("UTAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d19230_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Isa_vue__ = __webpack_require__("9C2f");
function injectStyle (ssrContext) {
  __webpack_require__("UaAa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13d19230"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Isa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d19230_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Isa_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KzMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "viewer"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "nav-next",
    on: {
      "click": function($event) {
        _vm.selectNext()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-previous",
    on: {
      "click": function($event) {
        _vm.selectPrev()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle",
    on: {
      "click": _vm.toggle
    }
  })]), _vm._v(" "), (_vm.img) ? _c('div', {
    staticClass: "slide active"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v(_vm._s(_vm.img.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.img.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: "url(" + _vm.img.imgix_url + ")",
      backgroundSize: "contain",
      backgroundPosition: "center"
    })
  })]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef5a1e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("1Lxr");
function injectStyle (ssrContext) {
  __webpack_require__("RlxH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef5a1e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "RlxH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ShYa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ "UB0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thumbs_vue__ = __webpack_require__("WZNU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e1114e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Thumbs_vue__ = __webpack_require__("VcO6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e1114e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Thumbs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UTAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'isa',
    beforeCreate: function beforeCreate() {
        document.body.className = 'isa';
    },
    data: function data() {
        return {
            heading: 'Imprecise Probability - A Gentle Overview',
            subheading: 'ISA short course'
        };
    }
});

/***/ }),

/***/ "UaAa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VcO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "thumbnails"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('article', {
      class: {
        'active': _vm.activeIndex == index
      }
    }, [_c('a', {
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.selectImage(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgix_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WZNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("ShYa");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'thumbs',
    created: function created() {
        var _this = this;

        this.items = [{ 'imgix_url': 'static/gallery/DSC_6067.jpg' }, { 'imgix_url': 'static/gallery/DSC_6085.jpg' }, { 'imgix_url': 'static/gallery/DSC_6096.jpg' }, { 'imgix_url': 'static/gallery/DSC_6100.jpg' }, { 'imgix_url': 'static/gallery/DSC_6105.jpg' }, { 'imgix_url': 'static/gallery/DSC_6106.jpg' }, { 'imgix_url': 'static/gallery/DSC_6107.jpg' }, { 'imgix_url': 'static/gallery/DSC_6109.jpg' }, { 'imgix_url': 'static/gallery/DSC_6110.jpg' }, { 'imgix_url': 'static/gallery/DSC_6111.jpg' }, { 'imgix_url': 'static/gallery/DSC_6112.jpg' }, { 'imgix_url': 'static/gallery/DSC_6113.jpg' }, { 'imgix_url': 'static/gallery/DSC_6116.jpg' }, { 'imgix_url': 'static/gallery/DSC_6121.jpg' }, { 'imgix_url': 'static/gallery/DSC_6122.jpg' }, { 'imgix_url': 'static/gallery/DSC_6123.jpg' }, { 'imgix_url': 'static/gallery/DSC_6126.jpg' }, { 'imgix_url': 'static/gallery/DSC_6127.jpg' }, { 'imgix_url': 'static/gallery/DSC_6128.jpg' }, { 'imgix_url': 'static/gallery/DSC_6129.jpg' }, { 'imgix_url': 'static/gallery/DSC_6131.jpg' }, { 'imgix_url': 'static/gallery/DSC_6132.jpg' }, { 'imgix_url': 'static/gallery/DSC_6134.jpg' }, { 'imgix_url': 'static/gallery/DSC_6142.jpg' }, { 'imgix_url': 'static/gallery/DSC_6146.jpg' }, { 'imgix_url': 'static/gallery/DSC_6147.jpg' }, { 'imgix_url': 'static/gallery/DSC_6152.jpg' }, { 'imgix_url': 'static/gallery/DSC_6154.jpg' }, { 'imgix_url': 'static/gallery/DSC_6159.jpg' }, { 'imgix_url': 'static/gallery/DSC_6161.jpg' }, { 'imgix_url': 'static/gallery/DSC_6169.jpg' }, { 'imgix_url': 'static/gallery/DSC_6171.jpg' }, { 'imgix_url': 'static/gallery/DSC_6173.jpg' }, { 'imgix_url': 'static/gallery/DSC_6176.jpg' }, { 'imgix_url': 'static/gallery/DSC_6181.jpg' }, { 'imgix_url': 'static/gallery/DSC_6182.jpg' }, { 'imgix_url': 'static/gallery/DSC_6184.jpg' }, { 'imgix_url': 'static/gallery/DSC_6185.jpg' }, { 'imgix_url': 'static/gallery/DSC_6186.jpg' }, { 'imgix_url': 'static/gallery/DSC_6187.jpg' }, { 'imgix_url': 'static/gallery/DSC_6188.jpg' }, { 'imgix_url': 'static/gallery/DSC_6189.jpg' }, { 'imgix_url': 'static/gallery/DSC_6190.jpg' }, { 'imgix_url': 'static/gallery/DSC_6191.jpg' }, { 'imgix_url': 'static/gallery/DSC_6192.jpg' }, { 'imgix_url': 'static/gallery/DSC_6195.jpg' }, { 'imgix_url': 'static/gallery/DSC_6196.jpg' }, { 'imgix_url': 'static/gallery/DSC_6203.jpg' }];

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$on('move', function (dir) {
            _this.activeIndex = _this.activeIndex + dir;
            if (dir > 0 && _this.activeIndex >= _this.items.length) {
                _this.activeIndex = 0;
            }
            if (dir < 0 && _this.activeIndex < 0) {
                _this.activeIndex = _this.items.length - 1;
            }
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$emit('loaded', _this.items[_this.activeIndex]);
        });

        console.log('th_em', this.items);
    },
    data: function data() {
        return {
            items: [],
            activeIndex: 0
        };
    },

    methods: {
        selectImage: function selectImage(itm, index) {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$emit('loaded', itm);
            this.activeIndex = index;
        }
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_body_class__ = __webpack_require__("yfhv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_body_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_body_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Isa__ = __webpack_require__("JAO3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Gallery__ = __webpack_require__("sl25");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/isa',
    name: 'Isa',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Isa__["a" /* default */]
  }, {
    path: '/gallery',
    name: 'Gallery',
    meta: { bodyClass: 'gallery' },
    component: __WEBPACK_IMPORTED_MODULE_5__components_Gallery__["a" /* default */]
  }]
}));

/***/ }),

/***/ "hbw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('app-header'), _vm._v(" "), _c('thumbs'), _vm._v(" "), _c('div', {
    staticClass: "toggle"
  })], 1), _vm._v(" "), _c('viewer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iCKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.heading) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "is-two-thirds column is-paddingless"
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns pd is-multiline is-desktop"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds-desktop"
  }, [_c('div', {
    staticClass: "card schedule"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Schedule of events")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Tuesday, 14th of November, 2017")]), _vm._v(" "), _c('ul', {
    staticClass: "subtitle is-vcentered"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("9.30 am - 3.30 pm:")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "isa"
    }
  }, [_vm._v("ISA short course \"Imprecise Probability - A Gentle Overview\"")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "http://www.eeecs.qub.ac.uk/~c.decampos/",
      "target": "_blank"
    }
  }, [_vm._v("Cassio P. de Campos")]), _vm._v(" (Queen's University Belfast) and "), _c('a', {
    attrs: {
      "href": "http://people.idsia.ch/~alessandro/",
      "target": "_blank"
    }
  }, [_vm._v("Alessandro Antonucci")]), _vm._v(" (Swiss AI Lab IDSIA)")], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns pd is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("9MfB"),
      "alt": "TCD"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-desktop info"
  }, [_c('p', [_vm._v("\n            The "), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/disciplines/statistics/",
      "target": "_blank"
    }
  }, [_vm._v("Discipline of Statistics")]), _vm._v(" (formerly Department of Statistics) at "), _c('a', {
    attrs: {
      "href": "www.tcd.ie",
      "target": "_blank"
    }
  }, [_vm._v("Trinity College Dublin")]), _vm._v(" is celebrating its 50th year in 2017. This special milestone will be marked by the organisation of an ISA short course and an afternoon of talks, followed by a reception, on Tuesday 14th November.\n          ")]), _vm._v(" "), _c('p', [_vm._v("If you have had a connection to the Department/Discipline in the past as a member of staff, visitor, student or other and would like to receive an RSVP invitation to this event, contact "), _c('a', {
    attrs: {
      "href": "mailto:wyseja@tcd.ie"
    }
  }, [_vm._v("wyseja@tcd.ie")]), _vm._v(".")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Venue of the event")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.google.ie/maps/place/O'Callaghan+Mont+Clare+Hotel/@53.3414972,-6.2530017,17z/data=!3m1!4b1!4m5!3m4!1s0x48670e90db4a8129:0xcf06339f781c38e2!8m2!3d53.341494!4d-6.250813",
      "target": "_blank"
    }
  }, [_vm._v("\n                O'Callaghan Mont Clare Hotel"), _c('br'), _vm._v("\n                1-4 Merrion Street Lower, Dublin 2\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Local organising committee")]), _vm._v(" "), _c('ul', {
    staticClass: "subtitle is-vcentered"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/Brett.Houlding/Home.html",
      "target": "_blank"
    }
  }, [_vm._v("Brett Houlding")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.bernardonipoti.com/",
      "target": "_blank"
    }
  }, [_vm._v("Bernardo Nipoti")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "http://people.tcd.ie/Profile?Username=moregan",
      "target": "_blank"
    }
  }, [_vm._v("Myra O’Regan")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/~arwhite/",
      "target": "_blank"
    }
  }, [_vm._v("Arthur White")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/disciplines/statistics/statica/statica_web/Wilson.html",
      "target": "_blank"
    }
  }, [_vm._v("Simon Wilson")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://sites.google.com/site/jsnwyse/",
      "target": "_blank"
    }
  }, [_vm._v("Jason Wyse")])])])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:00 pm:")]), _vm._v(" Welcome (Prof. Simon Wilson)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:05 pm:")]), _vm._v(" A look at the history of the department (Dr. Michael Stuart)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:20 pm:")]), _vm._v(" Discussion and reminisce with former members of the Statistics Department")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:50 pm:")]), _vm._v(" Panel discussion on the future of and opportunities for statistics at Trinity College, in Ireland and beyond - Panel members: Prof. Adrian Raftery (University of Washington), Dr. Chris Sibley (Central Statistics Office), Mr. Kieran Towey (Accenture Advanced Analytics), Prof. Nial Friel (University College Dublin)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("5:40 pm:")]), _vm._v(" Close and walk over to the "), _c('a', {
    attrs: {
      "href": "https://www.tcd.ie/Maps/map.php?b=194",
      "target": "_blank"
    }
  }, [_vm._v("O’Reilly Institute")]), _vm._v(" foyer for buffet and wine reception")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("6.00 pm:")]), _vm._v(" Reception at the "), _c('a', {
    attrs: {
      "href": "https://www.tcd.ie/Maps/map.php?b=194",
      "target": "_blank"
    }
  }, [_vm._v("O’Reilly Institute")]), _vm._v(" foyer")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae93e884_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("iCKH");
function injectStyle (ssrContext) {
  __webpack_require__("p2sc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae93e884"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae93e884_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n26P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ISAlogo200px.3baebb9.png";

/***/ }),

/***/ "nNh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-header',
    data: function data() {
        return {
            header: 'Stats50 Gallery',
            text: 'Event\'s Photo Gallery'

        };
    }
});

/***/ }),

/***/ "p2sc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sl25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("HKjq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc0487a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("hbw2");
function injectStyle (ssrContext) {
  __webpack_require__("Id0d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cc0487a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc0487a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vNKR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("ShYa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'viewer',
    created: function created() {
        var _this = this;

        this.img = { 'imgix_url': 'static/gallery/DSC_6067.jpg' };

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$on('loaded', function (obj) {
            _this.img = obj;
        });
    },
    data: function data() {
        return {
            img: null
        };
    },

    methods: {
        selectNext: function selectNext() {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$emit('move', 1);
        },
        selectPrev: function selectPrev() {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$emit('move', -1);
        },
        toggle: function toggle() {
            console.log('io');
            if (document.body.classList.contains('fullscreen')) this.show();else this.hide();
        },
        show: function show() {
            // Already visible? Bail.
            if (!document.body.classList.contains('fullscreen')) return;

            // Show main wrapper.
            document.body.classList.remove('fullscreen');

            // Focus.
            document.getElementById('main').focus();
        },


        /**
         * Hides the main wrapper.
         */
        hide: function hide() {

            // Already hidden? Bail.
            if (document.body.classList.contains('fullscreen')) return;

            // Hide main wrapper.
            document.body.classList.add('fullscreen');

            // Blur.
            document.getElementById('main').blur();
        }
    }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            isActive: false
        };
    },
    methods: {
        toggleBurger: function toggleBurger() {
            this.isActive = !this.isActive;
        }
    }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c00a5cacd1fe6d0054e7.js